import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AlarmConfig } from '@core/interfaces/alarm-config';
import { DatabaseService } from '@core/services/database.service';
import { UrlService } from '@core/services/url.service';
import { FileIsometricAlarmConfigs } from '@orm-entities/file-isometric-alarm-configs';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IsometricAlarmService {
  #httpClient = inject(HttpClient);
  #urlService = inject(UrlService);
  #databaseService = inject(DatabaseService);

  public fetchInteractiveIsometricAlarmConfiguration(cmlJsonFileId: string): Observable<AlarmConfig> {
    const url = this.#urlService.getUrl(`interactive-isometrics/${cmlJsonFileId}/alarm`);
    return this.#httpClient.get<AlarmConfig>(url);
  }

  public loadInteractiveIsometricAlarmConfiguration(cmlJsonFileId: string): Observable<AlarmConfig> {
    return this.#databaseService.select(FileIsometricAlarmConfigs, { cmlJsonFileId }).pipe(
      map(alarm => {
        if (alarm.length === 0) {
          return null;
        }
        const enableAlarm = alarm[0].enableAlarm.toString();
        const confirmBeforeSave = alarm[0].confirmBeforeSave.toString();
        return {
          id: alarm[0].id,
          fileId: alarm[0].fileId,
          alarmLow: alarm[0].alarmLow,
          alarmHigh: alarm[0].alarmHigh,
          enableAlarm: enableAlarm === 'true' || enableAlarm === '1',
          confirmBeforeSave: confirmBeforeSave === 'true' || confirmBeforeSave === '1',
          alarmType: alarm[0].alarmType as 'Percentage' | 'Numerical',
        };
      }),
    );
  }
}
